import React from 'react';

import ContinueApple from './ContinueApple'
import RegisterAppleForm from './RegisterAppleForm'

import AppVars from '../../AppVars.js';
import Logger from '../../Logger.js';


const appVars = AppVars.getInstance();
const logger = Logger.getInstance();


class FinishApple extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            payload: null
        }
        this.savePayload = this.savePayload.bind(this);
    }

    savePayload(value) {
        this.setState({payload: value});
      }


    render(){
        return(<div>
            {this.state.payload === null ? <ContinueApple style = {sessionStorage.AP_STYLE} savePayload = {this.savePayload} /> : null }
            {this.state.payload != null ? <RegisterAppleForm style = {sessionStorage.AP_STYLE} payload = {this.state.payload} /> : null}

            </div>
        )
    }
}
    


export default FinishApple;